module.exports = __webpack_public_path__ + "img/amx.72e94bae.webp";